module.exports = __webpack_public_path__ + "img/XRP.2d85f434.svg";